<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <license-filter/>
    </div>
    <div class="aco-details-box">
      <license-list/>
    </div>
  </div>
</template>

<script>
  import LicenseFilter from './LicenseFilter'
  import LicenseList from './LicenseList'

  export default {
    components: {
      licenseFilter: LicenseFilter,
      licenseList: LicenseList
    }
  }
</script>
